import styled from 'styled-components';

export const VerticalDivider = styled.div`
  width: 1px;
  margin: 0px 30px;
  background-color: ${(props) => props.theme.colors.grayLine};
`;

export const HorizontalDivider = styled.div`
  height: 1px;
  margin: '30px 0px';
  background-color: ${(props) => props.theme.colors.grayLine};
`;

export const LXDivider = styled.div<{ width?: string; margin?: string }>`
  height: 1px;
  margin: '0px 0px';
  width: ${(props) => props.width ?? '100%'};
  margin: ${(props) => props.margin};
  background-color: ${(props) => props.theme.colors.grayLine};
`;
